import { Controller } from "@hotwired/stimulus";
import { setTriggerExpanded } from "../../utils/disclosure.js";

/**
 * GO4S Design System — ExportButton (choix des colonnes -> Excel / PDF).
 * Construit l'URL d'export avec format + columns[] ; sinon toast de démo.
 * Spec : docs/design-system/REFERENCE.md §3
 */
export default class extends Controller {
  static targets = ["panel", "col", "trigger"];
  static values = { url: String };

  connect() {
    this.onDoc = this.onDoc.bind(this);
  }

  disconnect() {
    document.removeEventListener("mousedown", this.onDoc);
  }

  setExpanded(v) {
    setTriggerExpanded(this, v);
  }

  toggle() {
    this.panelTarget.hidden ? this.open() : this.close();
  }

  open() {
    this.panelTarget.hidden = false;
    this.setExpanded(true);
    document.addEventListener("mousedown", this.onDoc);
  }

  close() {
    this.panelTarget.hidden = true;
    this.setExpanded(false);
    document.removeEventListener("mousedown", this.onDoc);
  }

  onDoc(e) {
    if (!this.element.contains(e.target)) this.close();
  }

  export(event) {
    const format = event.currentTarget.dataset.format;
    const cols = this.colTargets.filter((c) => c.checked).map((c) => c.value);
    if (this.urlValue) {
      const url = new URL(this.urlValue, window.location.origin);
      url.searchParams.set("format", format);
      cols.forEach((c) => url.searchParams.append("columns[]", c));
      window.location.href = url.toString();
    } else if (window.g4sToast) {
      window.g4sToast({
        tone: "success",
        title: `Export ${format.toUpperCase()}`,
        message: `${cols.length} colonne(s) sélectionnée(s).`,
      });
    }
    this.close();
  }
}
